const React = require('react')
require('prismjs/themes/prism-okaidia.css')
require('katex/dist/katex.min.css')
require('./src/styles/style.css')
require('./src/styles/new-moon.css')
require('./src/styles/context-menu.css')
require('yet-another-react-lightbox/styles.css')
export function wrapPageElement({ element, props }) {
  const Layout = element.type.Layout ?? React.Fragment

  return <Layout {...props}>{element}</Layout>
}
require('prismjs/plugins/line-numbers/prism-line-numbers.css')
require('prismjs/plugins/command-line/prism-command-line.css')
require('prismjs/plugins/treeview/prism-treeview.css')
require('prismjs/plugins/treeview/prism-treeview.js')

// File module: gatsby-browser.js
const GTM_ID = 'GT-MR29P3XK'
const GA4_ID = 'G-FCXGTZE8DE'
let gtagLoaded = false

function loadGtag() {
  if (gtagLoaded || typeof window === 'undefined') return
  if (window.gtag) {
    gtagLoaded = true
    return
  }
  if (document.getElementById('gtag-js')) {
    gtagLoaded = true
    return
  }

  window.dataLayer = window.dataLayer || []
  window.gtag = function gtag() {
    window.dataLayer.push(arguments)
  }

  const s = document.createElement('script')
  s.id = 'gtag-js'
  s.async = true
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GTM_ID}`
  document.head.appendChild(s)

  window.gtag('js', new Date())

  // Konfigurasi Google Tag container
  window.gtag('config', GTM_ID)
  // Konfigurasi GA4
  window.gtag('config', GA4_ID, { send_page_view: false })

  gtagLoaded = true
}

export const onClientEntry = () => {
  if (process.env.NODE_ENV !== 'production') return

  // Tunda load GTM lebih lama (10 detik) atau tunggu interaksi user
  // Ini trik untuk mencapai skor Lighthouse 100 (menghindari 'Unused JavaScript' di awal load)
  if ('requestIdleCallback' in window) {
    requestIdleCallback(loadGtag, { timeout: 10000 })
  } else {
    setTimeout(loadGtag, 10000)
  }

  const once = (fn) => {
    let done = false
    return (...args) => {
      if (done) return
      done = true
      fn(...args)
    }
  }
  window.addEventListener('pointerdown', once(loadGtag), { passive: true })
  window.addEventListener('scroll', once(loadGtag), { passive: true })
}

export const onRouteUpdate = ({ location }) => {
  // 1. Patch iframe YouTube / embed video dulu (jalan di dev & prod)
  if (typeof document !== 'undefined') {
    const iframes = document.querySelectorAll(
      '.embedVideo-container iframe,' + // dari gatsby-remark-embed-video
      'iframe[src*="youtube.com/embed"],' +
      'iframe[src*="youtube-nocookie.com/embed"]'
    )

    iframes.forEach((iframe) => {
      // kalau belum ada referrerPolicy, set ke strict-origin-when-cross-origin
      if (!iframe.referrerPolicy) {
        iframe.referrerPolicy = 'strict-origin-when-cross-origin'
      }
    })

    // Re-initialize Twitter embeds
    if (window.twttr && window.twttr.widgets) {
      // Set current theme from layout if available
      const currentTheme = typeof window !== 'undefined' ? (window.localStorage.getItem('theme') || 'dark') : 'dark'
      document.querySelectorAll('blockquote.twitter-tweet').forEach(el => {
        el.setAttribute('data-theme', currentTheme)
      })
      window.twttr.widgets.load()
    }
  }

  // 2. Bagian analytics (seperti sebelumnya, hanya di production)
  if (process.env.NODE_ENV !== 'production') return
  if (!window.gtag) return

  window.gtag('event', 'page_view', {
    page_location: location.href,
    page_path: location.pathname,
    page_title: document.title,
  })
}

// Suppress giscus console messages (but NOT my debug logs)
if (typeof window !== 'undefined') {
  const shouldFilterGiscus = (args) => {
    try {
      const message = args.map(arg => {
        if (typeof arg === 'string') return arg
        if (arg && typeof arg === 'object') return JSON.stringify(arg)
        return String(arg)
      }).join(' ')

      // Filter giscus-related messages, but allow my specific debug logs
      if (message.includes('🌓') || message.includes('🐦') || message.includes('📢')) return false

      return (
        message.includes('giscus.app/api/discussions') ||
        message.includes('[giscus]') ||
        (message.includes('GET') && message.includes('giscus'))
      )
    } catch (e) {
      return false
    }
  }

  const originalError = console.error
  const originalLog = console.log
  const originalWarn = console.warn

  console.error = function (...args) {
    if (shouldFilterGiscus(args)) return
    originalError.apply(console, args)
  }

  console.log = function (...args) {
    if (shouldFilterGiscus(args)) return
    originalLog.apply(console, args)
  }

  console.warn = function (...args) {
    if (shouldFilterGiscus(args)) return
    originalWarn.apply(console, args)
  }
}

// --- GLOBAL EVENT LISTENER FOR THEME CHANGES ---
if (typeof window !== 'undefined') {
  window.addEventListener('theme-change', (e) => {
    const newTheme = e.detail.theme
    console.log('🌓 [Blog Theme] Changed to:', newTheme)
    
    // 1. Update Giscus Theme (Instantly via postMessage)
    const giscusIframe = document.querySelector('iframe.giscus-frame')
    if (giscusIframe) {
      console.log('💬 [Komentar] Updating Giscus theme...')
      giscusIframe.contentWindow.postMessage(
        { giscus: { setConfig: { theme: newTheme } } },
        'https://giscus.app'
      )
    }

    // 2. Refresh Twitter Widgets (Real-time re-render)
    if (window.twttr && window.twttr.widgets) {
      console.log('🐦 [Twitter] Triggering re-render...')
      
      // Better selector: find both rendered iframes and the parent container that Twitter adds
      const renderedTweets = document.querySelectorAll('iframe.twitter-tweet-rendered, .twitter-tweet-rendered iframe, iframe[id^="twitter-widget-"]')
      console.log(`🐦 [Twitter] Found ${renderedTweets.length} rendered tweets`)
      
      renderedTweets.forEach(iframe => {
        let tweetId = iframe.getAttribute('data-tweet-id')
        
        if (!tweetId) {
          try {
            const url = new URL(iframe.src)
            tweetId = url.searchParams.get('id')
          } catch (e) {}
        }

        console.log(`🐦 [Twitter] Processing Tweet ID: ${tweetId}`)

        if (!tweetId) return

        // Find the outermost wrapper if it exists (Twitter often wraps in a div or span)
        let targetToReplace = iframe
        if (iframe.parentElement && iframe.parentElement.classList.contains('twitter-tweet-rendered')) {
          targetToReplace = iframe.parentElement
        }

        const container = targetToReplace.parentElement
        if (!container) return

        // Create a new blockquote as a placeholder for the new theme
        const newBlockquote = document.createElement('blockquote')
        newBlockquote.className = 'twitter-tweet'
        newBlockquote.setAttribute('data-theme', newTheme)
        newBlockquote.setAttribute('data-dnt', 'true')
        
        const link = document.createElement('a')
        link.href = `https://twitter.com/x/status/${tweetId}`
        newBlockquote.appendChild(link)

        // Replace old iframe/wrapper with new blockquote
        container.replaceChild(newBlockquote, targetToReplace)
        console.log(`🐦 [Twitter] Replaced tweet ${tweetId} with blockquote placeholder`)
      })

      // Update any other remaining blockquotes
      document.querySelectorAll('blockquote.twitter-tweet').forEach(el => {
        el.setAttribute('data-theme', newTheme)
      })

      // Re-run the loader
      console.log('🐦 [Twitter] Calling widgets.load()...')
      window.twttr.widgets.load()
    } else {
      console.warn('🐦 [Twitter] widgets.js not found')
    }
  })
}

function printBanner() {
  if (typeof window === 'undefined') return
  const text = ` 
░█▀█░█▀█░█▀▀░█▀▀░█░░░▀█▀░█▀█░░░█▀█░█▀█░▀▀█░█▀█░█▀█░▀█▀░░░▀█▀░█▀▀░█░░░█▀█░█░█░█▄█░░░█▀▄░█▀█░█▀█░█░█░█▀█
░█▀█░█░█░█░█░█▀▀░█░░░░█░░█▀█░░░█▀█░█░█░░░█░█▀█░█░█░░█░░░░░█░░█▀▀░█░░░█▀█░█░█░█░█░░░█▀▄░█▀█░█░█░█░█░█▀█
░▀░▀░▀░▀░▀▀▀░▀▀▀░▀▀▀░▀▀▀░▀░▀░░░▀░▀░▀░▀░▀▀░░▀░▀░▀░▀░▀▀▀░░░░▀░░▀▀▀░▀▀▀░▀░▀░▀▀▀░▀░▀░░░▀▀░░▀░▀░▀░▀░▀▀▀░▀░▀
  `
  const style = 'color: #51b681; font-size: 12px; font-weight: 700;'
  // eslint-disable-next-line no-console
  console.log('%c' + text, style)
  console.log("%cMade with ❤️ by Aksara", "color: #9333ea; font-style: italic;");
}

export const onInitialClientRender = () => {
  printBanner()

  if (typeof window !== 'undefined') {
    // 1. Set initial theme for any Twitter blockquotes BEFORE loading script
    const currentTheme = window.localStorage.getItem('theme') || 'dark'
    document.querySelectorAll('blockquote.twitter-tweet').forEach(el => {
      if (!el.hasAttribute('data-theme')) {
        el.setAttribute('data-theme', currentTheme)
      }
    })

    // 2. Load Twitter widgets.js
    if (!window.twttr) {
      const s = document.createElement('script')
      s.setAttribute('src', 'https://platform.twitter.com/widgets.js')
      s.setAttribute('async', 'true')
      s.setAttribute('charset', 'utf-8')
      document.head.appendChild(s)
    }
  }
}
